import api from "@/api/api";

export const getOrgUsers = async (orgId) => {
  const res = await api.get(`/organizations/${orgId}/users`);
  return res.data?.users || [];
};
